<template>
    <div class="capacity-wrap">
        <div class="capacity-title-wrap">
            <div class="leader-radio">
                <el-radio-group
                    v-model="selectAccount"
                    v-for="item in accounts"
                    :key="item.elec_customer_account_id"
                    @change="toggleTab(item.elec_customer_account_id)"
                    size="medium"
                >
                    <el-radio-button :label="item.account_name" style="margin-right: 10px"></el-radio-button>
                </el-radio-group>
            </div>

            <div class="incoming-card-btn">
                <el-form
                    :inline="true"
                    :model="searchForm"
                    ref="searchForm"
                    :rules="searchFormRule"
                    class="leader-style-form"
                >
                    <el-form-item prop="selectDate" class="timePicker">
                        <el-date-picker
                            :picker-options="pickerDisabled"
                            v-model="searchForm.selectDate"
                            type="month"
                            placeholder="请选择时间"
                            :default-value="selectDate"
                            :clearable="false"
                            value-format="yyyy-MM"
                            format="yyyy-MM"
                            @change="yymm"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            icon="el-icon-caret-left"
                            @click="frontMonthClick"
                            size="medium"
                            class="time_btn"
                        >上一月</el-button>
                        <el-button
                            @click="nextMonthClick"
                            :disabled="
                                this.sysDate === this.searchForm.selectDate
                            "
                            size="medium"
                            class="time_btn"
                        >
                            下一月
                            <i class="el-icon-caret-right"></i>
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            @click="search"
                            style="float:right;"
                            type="warning"
                            size="medium"
                        >查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <el-scrollbar style="height: 90%">
            <el-row :gutter="20" style="margin-top: 20px">
                <el-col :sm="8" :md="8" :lg="8" :xl="8">
                    <el-card class="card1">
                        <div class="card-title">容量</div>
                        <div class="card-data">
                            {{ capacity }}
                            <span>kVA</span>
                        </div>
                    </el-card>
                </el-col>
                <el-col :sm="8" :md="8" :lg="8" :xl="8">
                    <el-card class="card2">
                        <div class="card-title">最大需量</div>
                        <div class="card-data">
                            {{ maxdemand }}
                            <span>kW</span>
                        </div>
                    </el-card>
                </el-col>
                <el-col :sm="8" :md="8" :lg="8" :xl="8">
                    <el-card class="card3">
                        <div class="card-title">{{ maxdemand_year }}最大需量发生时间</div>
                        <div class="card-data">{{ maxdemand_time }}</div>
                    </el-card>
                </el-col>
            </el-row>

            <div class="echart-container">
                <div
                    style="text-align: left; font-size: 16px; color: #fff;border-left:5px solid #56fcff; padding-left: 10px;margin-top: 20px"
                >容量电费/需量电费</div>
                <div style="text-align: right; margin-bottom: 10px">
                    <el-button class="leader-common-button" @click="showRongxuChart('chart')">图表</el-button>
                    <el-button class="leader-common-button" @click="showRongxuChart('table')">数据</el-button>
                </div>
                <v-chart
                    :auto-resize="true"
                    :options="rongxuChart"
                    ref="rongxuChart"
                    theme="ovilia-green"
                    v-if="showRongxuCharts"
                />
                <common-table :tableData="tableRongXuData" :columns="colsRongXu" v-else></common-table>

                <div style="text-align: right; margin-bottom: 10px; ">
                    <el-button class="leader-common-button" @click="showYearChart('chart')">图表</el-button>
                    <el-button class="leader-common-button" @click="showYearChart('table')">数据</el-button>
                    <!-- <el-button
                        class="leader-common-button"
                        @click="exportMonthDemand"*/-
                        >导出
                        
                    </el-button>-->
                </div>
                <div
                    style="text-align: left; font-size: 16px; color: #fff;border-left:5px solid #56fcff; padding-left: 10px;margin-top: 20px"
                >月度需量(点击可查看日)</div>
                <v-chart
                    :auto-resize="true"
                    :options="barYear"
                    ref="barYear"
                    theme="ovilia-green"
                    v-if="showYearCharts"
                    @click="clickYearBar"
                />
                <common-table :tableData="tableYearData" :columns="colsYear" v-else></common-table>

                <template v-if="showMonth">
                    <div
                        style="text-align: center; font-size: 16px; padding-left: 10px; color:#fff"
                    >{{ yearMonth }}</div>
                    <div style="text-align: right; margin-bottom: 10px">
                        <el-button class="leader-common-button" @click="showMonthChart('chart')">图表</el-button>
                        <el-button class="leader-common-button" @click="showMonthChart('table')">数据</el-button>
                        <!-- <el-button
                            class="leader-common-button"
                            @click="exportDayDemand"
                            >导出
                        </el-button>-->
                    </div>
                    <v-chart
                        :auto-resize="true"
                        :options="barMonth"
                        ref="barMonth"
                        theme="ovilia-green"
                        v-if="showMonthCharts"
                        @click="clickMonthBar"
                    />
                    <common-table :tableData="tableMonthData" :columns="colsMonth" v-else></common-table>
                </template>

                <template v-if="showDay">
                    <div
                        style="text-align: center; font-size: 16px; color: #fff; padding-left: 10px"
                    >{{ monthDay }}</div>
                    <div style="text-align: right; margin-bottom: 10px">
                        <el-button class="leader-common-button" @click="showDayChart('chart')">图表</el-button>
                        <el-button class="leader-common-button" @click="showDayChart('table')">数据</el-button>
                        <!-- <el-button
                            class="leader-common-button"
                            @click="exportHourDemand"
                            >导出
                        </el-button>-->
                    </div>
                    <v-chart
                        :auto-resize="true"
                        :options="barDay"
                        ref="line"
                        theme="ovilia-green"
                        v-if="showDayCharts"
                    />
                    <common-table :tableData="tableDayData" :columns="colsDay" v-else></common-table>
                </template>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import CommonTable from "@/comon/components/common-table.vue";
import utils from "@/utils/utils";
import * as api from "@/http/hr";
import * as api1 from "@/http/api";
import { getAccounts, getSysDate } from "@/http/api";
import moment from "moment";
import { departmentColor } from "@/utils/chart-color.js";
export default {
    components: { CommonTable },
    props: {
        date: {
            type: String,
            required: true
        },
        account_id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            selectAccount: "", //选择的户号
            selectAccountId: "", //选择的户号id
            accounts: [], //户号列表
            sysDate: "", //系统时间
            searchForm: {
                selectDate: "" //选择的时间
            },
            pickerDisabled: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(
                            new Date(this.sysDate).toLocaleDateString()
                        ).getTime()
                    );
                }
            },
            searchFormRule: {
                selectDate: [
                    {
                        required: true,
                        message: "时间不能为空",
                        trigger: "change"
                    }
                ]
            },
            capacity: "", //容量
            maxdemand: "", //最大需量
            maxdemand_year: "", //最大需量
            maxdemand_time: "", //最大需量发生时间
            // 容量 需量
            showRongxuCharts: true,
            xAxisRongxu: [],
            yAxisRong: [],
            yAxisXu: [],
            tableRongXuData: [],
            colsRongXu: [
                { prop: "date", label: "日期" },
                { prop: "rong", label: "按容量计" },
                { prop: "xu", label: "按需量计" }
            ],
            //年月图表------------start-----
            showYearCharts: true, //是否显示年月图表
            tableYearData: [], //年月图表数据
            colsYear: [
                { prop: "date", label: "日期" },
                { prop: "name", label: "需量" }
            ],
            xAxisYear: [],
            yAxisYear: [],
            //年月图表------------end-----
            //月日图表------------start-----
            showMonth: false, //是否显示月日图表
            showMonthCharts: false, //是否显示月日图表
            yearMonth: "", //年月
            tableMonthData: [], //月日图表数据
            colsMonth: [
                { prop: "date", label: "日期" },
                { prop: "name", label: "需量" }
            ],
            xAxisMonth: [],
            yAxisMonth: [],
            //月日图表------------end-----
            //日时图表------------end-----
            showDay: false, //是否显示小时图表
            showDayCharts: false, //是否显示月日图表
            monthDay: "", //月
            tableDayData: [], //日图表数据
            colsDay: [
                { prop: "date", label: "日期" },
                { prop: "name", label: "需量" }
            ],
            xAxisDay: [],
            yAxisDay: []
            //日时图表------------start-----
        };
    },
    created() {
        // 获取系统时间
        this.getSysDate();
    },
    methods: {
        getMonthCapacityAndDemand() {
            api.getMonthCapacityAndDemand({
                elec_customer_account_id: this.selectAccountId,
                show_month: this.searchForm.selectDate
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxisRongxu = res.bus_json.x_list;
                    this.yAxisRong = res.bus_json.capacity_list;
                    this.yAxisXu = res.bus_json.maxdemand_list;
                }
            });
        },
        // 图表数据转换
        showRongxuChart(type) {
            this.tableRongXuData = [];
            for (let i = 0; i < this.xAxisRongxu.length; i++) {
                let obj = {};
                obj.date = this.xAxisRongxu[i];
                obj.rong = this.yAxisRong[i];
                obj.xu = this.yAxisXu[i];
                this.tableRongXuData.push(obj);
            }

            if (type === "chart") {
                this.showRongxuCharts = true;
            } else {
                this.showRongxuCharts = false;
            }
        },
        // 获取户号列表
        getAccounts() {
            getAccounts().then(res => {
                if (res && res.error_code === "0") {
                    this.accounts = res.bus_json;
                    this.selectAccount = res.bus_json[0].account_name;
                    this.selectAccountId =
                        res.bus_json[0].elec_customer_account_id;
                    this.getMonthDemandAndCapacity();
                    this.getMonthCapacityAndDemand();
                }
            });
        },
        // 获取系统时间
        getSysDate() {
            getSysDate().then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.selectDate = res.bus_json.sysdate3;
                    this.sysDate = res.bus_json.sysdate3;

                    // 获取户号
                    this.getAccounts();
                }
            });
        },
        // 上一月
        frontMonthClick() {
            const now = moment(this.searchForm.selectDate);
            this.searchForm.selectDate = now
                .subtract(1, "months")
                .format("YYYY-MM");
            this.getMonthDemandAndCapacity();
            this.getMonthCapacityAndDemand();
            this.showDay = false;
            this.showMonth = false;
        },
        //下一月
        nextMonthClick() {
            const now = moment(this.searchForm.selectDate);
            this.searchForm.selectDate = now.add(1, "months").format("YYYY-MM");
            this.getMonthDemandAndCapacity();
            this.getMonthCapacityAndDemand();
            this.showDay = false;
            this.showMonth = false;
        },
        // 查询
        search() {
            this.$refs["searchForm"].validate(valid => {
                if (valid) {
                    this.getMonthDemandAndCapacity();
                    this.getMonthCapacityAndDemand();
                    this.showDay = false;
                    this.showMonth = false;
                }
            });
        },
        // 获取年容量/需量
        getMonthDemandAndCapacity() {
            api.getMonthDemandAndCapacity({
                elec_customer_account_id: this.selectAccountId,
                show_month: this.searchForm.selectDate
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.capacity = res.bus_json.capacity;
                    this.maxdemand = res.bus_json.maxdemand;
                    this.maxdemand_time = res.bus_json.maxdemand_time;
                    this.xAxisYear = res.bus_json.x_list;
                    this.yAxisYear = res.bus_json.y_list;
                }
            });
        },
        // 年图表数据转换
        showYearChart(type) {
            this.tableYearData = [];
            for (let i = 0; i < this.yAxisYear.length; i++) {
                let obj = {};
                obj.date = this.xAxisYear[i];
                obj.name = this.yAxisYear[i];
                this.tableYearData.push(obj);
            }

            if (type === "chart") {
                this.showYearCharts = true;
            } else {
                this.showYearCharts = false;
            }
        },
        // 导出一年内12月的最大需量
        exportMonthDemand() {
            api.exportMonthDemand({
                elec_customer_account_id: this.selectAccountId,
                show_month: this.date
            }).then(res => {
                const content = res;
                const blob = new Blob([content]);
                const fileName = "最大需量" + ".xlsx";
                if ("download" in document.createElement("a")) {
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                } else {
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        },
        //年柱状图点击事件
        clickYearBar(params) {
            // 控制点击最大最小值不响应
            if (params.componentType !== "markPoint") {
                this.yearMonth = params.name;
                this.showMonth = true;
                this.showMonthCharts = true;
                this.showDay = false;
                this.getDayDemand(this.yearMonth);
            }
        },
        // 获取月容量/需量
        getDayDemand(date) {
            api.getDayDemand({
                show_month: date,
                elec_customer_account_id: this.selectAccountId
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxisMonth = res.bus_json.x_list;
                    this.yAxisMonth = res.bus_json.y_list;
                }
            });
        },
        // 导出一个月内每天最大需量
        exportDayDemand() {
            api.exportDayDemand({
                elec_customer_account_id: this.selectAccountId,
                show_month: this.yearMonth
            }).then(res => {
                const content = res;
                const blob = new Blob([content]);
                const fileName = this.yearMonth + "最大需量" + ".xlsx";
                if ("download" in document.createElement("a")) {
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                } else {
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        },
        // 月图表数据转换
        showMonthChart(type) {
            this.tableMonthData = [];
            for (let i = 0; i < this.yAxisMonth.length; i++) {
                let obj = {};
                obj.date = this.xAxisMonth[i];
                obj.name = this.yAxisMonth[i];
                this.tableMonthData.push(obj);
            }

            if (type === "chart") {
                this.showMonthCharts = true;
            } else {
                this.showMonthCharts = false;
            }
        },
        clickMonthBar(params) {
            // 控制点击最大最小值不响应
            if (params.componentType !== "markPoint") {
                this.monthDay = params.name;
                this.showDay = true;
                this.showDayCharts = true;
                this.getHourDemand(this.monthDay);
            }
        },
        // 获取日图表数据
        getHourDemand(date) {
            api.getHourDemand({
                show_day: date,
                elec_customer_account_id: this.selectAccountId
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxisDay = res.bus_json.x_list;
                    this.yAxisDay = [
                        {
                            // name: item.point_name,
                            name: "需量",
                            type: "bar",
                            barWidth: '50%',
                            data: res.bus_json.y_list,
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                        offset: 0,
                                        color: '#06B4F9'
                                    }, {
                                        offset: 1,
                                        color: '#092856'
                                    }]),
                                }
                            },
                            // smooth: true,
                            // symbol: "none"
                        }
                    ];
                    // if (
                    //     res.bus_json.content_list &&
                    //     res.bus_json.content_list.length
                    // ) {
                    //     res.bus_json.content_list.forEach(item => {
                    //         let data = item.y_list;
                    //         this.yAxisDay.push({
                    //             name: item.point_name,
                    //             type: "line",
                    //             data: data,
                    //             smooth: true,
                    //             symbol: "none"
                    //         });
                    //     });
                    // }
                }
            });
        },
        // 导出一个月内每天最大需量
        exportHourDemand() {
            api.exportHourDemand({
                elec_customer_account_id: this.selectAccountId,
                show_day: this.monthDay
            }).then(res => {
                const content = res;
                const blob = new Blob([content]);
                const fileName = this.monthDay + "最大需量" + ".xlsx";
                if ("download" in document.createElement("a")) {
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                } else {
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        },
        // 日图表数据转换
        showDayChart(type) {
            this.tableDayData = [];
            this.colsDay = [];
            this.colsDay = [{ prop: "date", label: "时间" }];
            for (let i = 0; i < this.yAxisDay.length; i++) {
                let item = {};
                item.prop = "value" + i;
                item.label = this.yAxisDay[i].name;
                this.colsDay.push(item);
            }
            if (this.yAxisDay.length > 0) {
                for (let j = 0; j < this.yAxisDay[0].data.length; j++) {
                    let obj = {};
                    obj.date = this.xAxisDay[j];
                    for (let k = 0; k < this.yAxisDay.length; k++) {
                        var keyName = "value" + k;
                        obj[keyName] = this.yAxisDay[k].data[j];
                    }
                    this.tableDayData.push(obj);
                }
            }

            if (type === "chart") {
                this.showDayCharts = true;
            } else {
                this.showDayCharts = false;
            }
        },
        toggleTab(val) {
            this.selectAccountId = val;
            this.getMonthDemandAndCapacity();
            this.getMonthCapacityAndDemand();
            this.showDay = false;
            this.showMonth = false;
        }
    },
    computed: {
        rongxuChart() {
            const options = {
                grid: {
                    left: "1%",
                    right: "0%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },

                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
              
                },
                legend: {
                    data: ["按容量计", "按需量计"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                color: ["#fe7f65", "#ffcb4f"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "月",
                        data: this.xAxisRongxu,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位: 元",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "按容量计",
                        type: "bar",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#F97464'
                                }, {
                                    offset: 1,
                                    color: '#FB3737'
                                }]),
                            }
                        },
                        data: this.yAxisRong
                    },
                    {
                        name: "按需量计",
                        type: "bar",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#F5E3B7'
                                }, {
                                    offset: 1,
                                    color: '#CB7A07'
                                }]),
                            }
                        },
                        data: this.yAxisXu
                    }
                ]
            };
            return options;
        },
        barYear() {
            const options = {
                grid: {
                    left: "0%",
                    right: "0%",
                    bottom: "5%",
                    top: "18%",
                    containLabel: true
                },

                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
            
                },
                legend: {
                    data: ["需量"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                color: ["#3398DB"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "月",
                        data: this.xAxisYear,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位: kW",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "需量",
                        type: "bar",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#06B4F9'
                                }, {
                                    offset: 1,
                                    color: '#092856'
                                }]),
                            }
                        },
                        data: this.yAxisYear,
                        markPoint: {
                            data: [{ type: "max", name: "最大值" }]
                        }
                    }
                ]
            };
            return options;
        },
        barMonth() {
            const options = {
                grid: {
                    left: "0%",
                    right: "2%",
                    bottom: "5%",
                    top: "18%",
                    containLabel: true
                },

                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
             
                },
                legend: {
                    data: ["需量"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                color: ["#3398DB"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "日",
                        axisLabel: {
                            rotate: -45,
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        },
                        data: this.xAxisMonth
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位: kW",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "需量",
                        type: "bar",
                        barWidth: '50%',
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#06B4F9'
                                }, {
                                    offset: 1,
                                    color: '#092856'
                                }]),
                            }
                        },
                        data: this.yAxisMonth,
                        markPoint: {
                            data: [{ type: "max", name: "最大值" }]
                        }
                    }
                ]
            };
            return options;
        },
        barDay() {
            const options = {
                grid: {
                    left: "0%",
                    right: "0%",
                    bottom: "5%",
                    top: "18%",
                    containLabel: true
                },

                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
              
                },
                legend: {
                    data: ["需量"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                color: ["#3398DB"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "小时",
                        data: this.xAxisDay,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位: kW",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: this.yAxisDay
                // series: [
                //     {
                //         name: '需量',
                //         type: 'line',
                //         // barWidth: '50%',
                //         data: this.yAxisDay,
                //         // markPoint: {
                //         //     data: [{ type: 'max', name: '最大值' }],
                //         // },
                //     },
                // ],
            };
            return options;
        }
    }
    // watch: {
    //     date: {
    //         handler(newValue) {
    //             this.date = newValue;
    //             this.maxdemand_year = this.date.substring(0, 4);
    //             if (this.date && this.account_id) {
    //                 this.getMonthDemandAndCapacity();
    //             }
    //         },
    //         deep: true,
    //         immediate: true,
    //     },
    //     account_id: {
    //         handler(newValue) {
    //             this.account_id = newValue;
    //             if (this.account_id && this.date) {
    //                 this.getMonthDemandAndCapacity();
    //             }
    //         },
    //         deep: true,
    //         immediate: true,
    //     },
    // },
};
</script>
<style lang="scss">
.capacity-wrap {
    width: 100%;
    height: 100%;
    padding: 0 px2Rem(40px);
    box-sizing: border-box;
    .capacity-title-wrap {
        display: flex;
        justify-content: space-between;
        margin-bottom: px2Rem(20px);
    }
    .el-radio-group{   margin-bottom: 0.5rem;}
    .card1 {
        border: none;
        text-align: left;
        height: px2Rem(120px);
        background: url("../../../assets/image/use_electricity_monitor/pinkBG.png") no-repeat;
        background-size: 100% 100%;
        text-align: left;
        box-shadow: 0 px2Rem(2px) px2Rem(12px) 0 rgba(0, 0, 0, 0.1);
    }

    .pink {
        width: 100%;
        background: url("../../../assets/image/use_electricity_monitor/pinkBG.png")
            no-repeat;
        background-size: 100% 100%;
    }
    .card2 {
        border: none;
        height: px2Rem(120px);
        text-align: left;
        background: url("../../../assets/image/use_electricity_monitor/pinkBG.png") no-repeat;
        background-size: 100% 100%;
        box-shadow: 0 px2Rem(2px) px2Rem(12px) 0 rgba(0, 0, 0, 0.1);
    }

    .card3 {
        border: none;
        height: px2Rem(120px);
        text-align: left;
        background: url("../../../assets/image/use_electricity_monitor/pinkBG.png") no-repeat;
        background-size: 100% 100%;
        box-shadow: 0 px2Rem(2px) px2Rem(12px) 0 rgba(0, 0, 0, 0.1);
    }
    .card-title {
        font-size: px2Rem(16px);
        color: #fff;
    }
    .card-data {
        font-size: px2Rem(36px);
        color: #fff;
        margin-top: px2Rem(25px);
        span {
            font-size: px2Rem(16px);
        }
    }
    .echart-container {
        width: 100%;

        .echarts {
            width: 100%;
            height: px2Rem(320px);
        }
    }
}
    .leader-style-form .el-form-item .el-form-item__content{padding-left:0!important}
</style>
